import React from 'react';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { usePageDataContextOptional } from '../../contexts/PageDataContext';

interface SubmitGroundfishProjectionData {
  /** Called when user clicks Recalculate Stocks. Runs the regular /run-forecast flow. */
  onSubmitGroundfish?: () => void | Promise<void>;
  /** Disabled when loading or updates are already in progress. */
  submitGroundfishDisabled?: boolean;
}

export default function SubmitGroundfishProjection(props: RegistryComponentProps): React.ReactElement {
  const pageData = usePageDataContextOptional();
  const data = getRegistryData<SubmitGroundfishProjectionData>(props);
  const onSubmit = data.onSubmitGroundfish ?? (pageData?.actions?.runGroundfishProjection as (() => void | Promise<void>) | undefined);
  const disabled = data.submitGroundfishDisabled ?? (pageData?.data?.updatingPStar as boolean | undefined) ?? false;

  const handleClick = React.useCallback(() => {
    if (typeof onSubmit === 'function') {
      void Promise.resolve(onSubmit());
    }
  }, [onSubmit]);

  return (
    <div className="noscroll-button-container" style={{ marginTop: '30px' }}>
      <button
        className="btn-primary noscroll-recalculate-all-button"
        onClick={handleClick}
        disabled={disabled}
      >
        Recalculate Stocks
      </button>
    </div>
  );
}
